import { Navigate, Route, Routes } from 'react-router-dom';

import { PreferencesAgentCopilotForm } from './preferencesAgentCopilotForm';
import { PreferencesConnectedDevicesView } from './preferencesConnectedDevices';
import { PreferencesGeneralForm } from './preferencesGeneralForm';
import { PreferencesKeyboardShortcutsForm } from './preferencesKeyboardShortcutsForm';
import { PreferencesSoundForm } from './preferencesSoundForm';

export const preferencesFormsRoutes = (
  <Routes>
    <Route index element={<Navigate to="sound" replace />} />
    <Route path="sound" element={<PreferencesSoundForm />} />
    <Route
      path="keyboard-shortcuts"
      element={<PreferencesKeyboardShortcutsForm />}
    />
    <Route path="agent-copilot" element={<PreferencesAgentCopilotForm />} />
    <Route path="devices/*" element={<PreferencesConnectedDevicesView />} />
    <Route path="general" element={<PreferencesGeneralForm />} />
  </Routes>
);
